// Browser storage service for persisting order and chat state
const STORAGE_KEYS = {
    ORDER_STATE: 'foh_order_state',
    CUSTOMER_INFO: 'foh_customer_info',
    FINAL_RECEIPT: 'foh_final_receipt',
    CHAT_MESSAGES: 'foh_chat_messages',
    CHAT_FLOW_STATE: 'foh_chat_flow_state',
    SESSION_ID: 'foh_session_id'
};

// Order state persistence
export const saveOrderState = (orderState) => {
    try {
        const sanitizedState = {
            ...orderState,
            isLoading: false,
            error: null
        };
        localStorage.setItem(STORAGE_KEYS.ORDER_STATE, JSON.stringify(sanitizedState));
    } catch (error) {
        console.error('❌ Failed to save order state:', error);
    }
};

export const loadOrderState = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEYS.ORDER_STATE);
        if (saved) {
            const orderState = JSON.parse(saved);
            return orderState;
        }
    } catch (error) {
        console.error('❌ Failed to load order state:', error);
    }
    return null;
};

export const clearAllData = () => {
    try {
        localStorage.removeItem(STORAGE_KEYS.ORDER_STATE);
        localStorage.removeItem(STORAGE_KEYS.CUSTOMER_INFO);
        localStorage.removeItem(STORAGE_KEYS.FINAL_RECEIPT);
        sessionStorage.removeItem(STORAGE_KEYS.CHAT_MESSAGES);
        sessionStorage.removeItem(STORAGE_KEYS.CHAT_FLOW_STATE);
        sessionStorage.removeItem(STORAGE_KEYS.SESSION_ID);
    } catch (error) {
        console.error('❌ Failed to clear stored data:', error);
    }
};

// Chat messages persistence
export const saveChatMessages = (messages) => {
    try {
        sessionStorage.setItem(STORAGE_KEYS.CHAT_MESSAGES, JSON.stringify(messages));
    } catch (error) {
        console.error('❌ Failed to save chat messages:', error);
    }
};

export const loadChatMessages = () => {
    try {
        const saved = sessionStorage.getItem(STORAGE_KEYS.CHAT_MESSAGES);
        if (saved) {
            const messages = JSON.parse(saved);
            return messages;
        }
    } catch (error) {
        console.error('❌ Failed to load chat messages:', error);
    }
    return [];
};

// Chat flow state persistence
export const saveChatFlowState = (flowState) => {
    try {
        sessionStorage.setItem(STORAGE_KEYS.CHAT_FLOW_STATE, JSON.stringify(flowState));
    } catch (error) {
        console.error('❌ Failed to save chat flow state:', error);
    }
};

export const loadChatFlowState = () => {
    try {
        const saved = sessionStorage.getItem(STORAGE_KEYS.CHAT_FLOW_STATE);
        if (saved) {
            const flowState = JSON.parse(saved);
            return flowState;
        }
    } catch (error) {
        console.error('❌ Failed to load chat flow state:', error);
    }
    return null;
};

// Customer info persistence
export const saveCustomerInfo = (info) => {
    try {
        if (!info) return;
        localStorage.setItem(STORAGE_KEYS.CUSTOMER_INFO, JSON.stringify(info));
    } catch (error) {
        console.error('❌ Failed to save customer info:', error);
    }
};

export const loadCustomerInfo = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEYS.CUSTOMER_INFO);
        if (saved) {
            const info = JSON.parse(saved);
            return info;
        }
    } catch (error) {
        console.error('❌ Failed to load customer info:', error);
    }
    return null;
};

// Final receipt persistence
export const saveFinalReceipt = (receiptData) => {
    try {
        if (!receiptData) return;
        localStorage.setItem(STORAGE_KEYS.FINAL_RECEIPT, JSON.stringify(receiptData));
    } catch (error) {
        console.error('❌ Failed to save final receipt:', error);
    }
};

export const loadFinalReceipt = () => {
    try {
        const saved = localStorage.getItem(STORAGE_KEYS.FINAL_RECEIPT);
        if (saved) {
            const receipt = JSON.parse(saved);
            return receipt;
        }
    } catch (error) {
        console.error('❌ Failed to load final receipt:', error);
    }
    return null;
};

export const clearFinalReceipt = () => {
    try {
        localStorage.removeItem(STORAGE_KEYS.FINAL_RECEIPT);
    } catch (error) {
        console.error('❌ Failed to clear final receipt:', error);
    }
};
